<template>
  <span class="mall-text-badge" :class="'mall-text-badge--' + type">{{ label }}</span>
</template>

<script>
export default {
  name: 'MallTextBadge',
  props: {
    label: {
      type: String,
      required: true,
    },
    // 'gray' | 'blue'
    type: {
      type: String,
      default: 'gray',
    },
  },
}
</script>

<style scoped>
/* 12px / 130% → Figma 렌더링 기준 16px */
.mall-text-badge {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 12px;
  font-family: Pretendard;
  font-size: var(--font-size-xxs);
  font-weight: var(--font-weight-medium);
  line-height: 16px;
  white-space: nowrap;
}

.mall-text-badge--gray {
  background: #F2F4F6;
  color: #4E5968;
}

.mall-text-badge--blue {
  background: #EFF9FF;
  color: #008DEF;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallTextBadge.vue